// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_uq-0";
export var checkoutRateBadgeLink = "_uq-1";